<form class="ui-search-field" role="search" (submit)="handleSubmit($event)">
  @if (hasLabel()) {
    <label class="ui-search-field-label" [attr.for]="inputId()">{{
      label()
    }}</label>
  }
  <span class="ui-search-field-control">
    <span class="ui-search-field-icon" aria-hidden="true"></span>
    <input
      #searchInput
      class="ui-search-field-input"
      type="search"
      [id]="inputId()"
      [attr.placeholder]="placeholder()"
      [attr.aria-label]="inputAriaLabel()"
      [value]="value()"
      [disabled]="disabled()"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
    />
    @if (hasValue()) {
      <button
        class="ui-search-field-clear"
        type="button"
        [disabled]="disabled()"
        [attr.aria-label]="clearLabel()"
        (click)="handleClear($event)"
      >
        ×
      </button>
    }
    <button
      class="ui-search-field-submit"
      type="submit"
      [disabled]="disabled()"
      [attr.aria-label]="submitLabel()"
    >
      ↵
    </button>
  </span>
</form>
